import { jsonToXlsx } from '@/utils/xlsExport/jsonToXlsx';
import staticData from './staticData';
import { pickOrderObj, formatFloat, checkOcultarCpa } from '@/utils/functions';
import i18n from '@/plugins/i18n';
import moment from 'moment';

export const exportXls = (data) => {
  const cols = staticData(true).columns;

  const hideCpa = checkOcultarCpa();
  const filteredCols = hideCpa
    ? cols.filter((col) => col.key !== 'reward_mark_count' && col.key !== 'reward_mark')
    : cols;

  jsonToXlsx({
    name: `${i18n.t('Affiliate Report')} - ${moment().format('DD-MM-YYYY HH:mm')}`,
    headers: filteredCols.map((c) => c.label),
    data: data.map((item) => {
      item.turnover = formatFloat(item?.turnover);
      item.turnover = formatFloat(item?.turnover);
      item.sub_brand_name = item?.sub_brand_name || '';
      item.active_customers_count = formatFloat(item?.active_customers_count);
      item.registered_customers_count = formatFloat(item?.registered_customers_count);
      item.bonus = formatFloat(item?.bonus);
      item.payout = formatFloat(item?.payout);
      item.ggr = formatFloat(item?.ggr);
      item.ngr = formatFloat(item?.ngr);
      item.admin_fee = formatFloat(item?.admin_fee);
      item.net = formatFloat(item?.net);
      item.reward_accumulative = formatFloat(item?.reward_accumulative);

      if (!hideCpa) {
        item.reward_mark_count = formatFloat(item?.reward_mark_count);
        item.reward_mark = formatFloat(item?.reward_mark);
      }

      item.reward_total = formatFloat(item?.reward_total);
      item.bets_turnover = formatFloat(item?.bets_turnover || 0);
      item.bets_payout = formatFloat(item?.bets_payout || 0);
      item.bets_bonus = formatFloat(item?.bets_bonus || 0);
      item.bets_reward = formatFloat(item?.bets_reward || 0);
      item.bets_admin_fee = formatFloat(item?.bets_admin_fee || 0);
      item.games_turnover = formatFloat(item?.games_turnover || 0);
      item.games_payout = formatFloat(item?.games_payout || 0);
      item.games_bonus = formatFloat(item?.games_bonus || 0);
      item.games_reward = formatFloat(item?.games_reward || 0);
      item.games_admin_fee = formatFloat(item?.games_admin_fee || 0);
      item.lotto_turnover = formatFloat(item?.lotto_turnover || 0);
      item.lotto_payout = formatFloat(item?.lotto_payout || 0);
      item.lotto_bonus = formatFloat(item?.lotto_bonus || 0);
      item.lotto_reward = formatFloat(item?.lotto_reward || 0);
      item.lotto_admin_fee = formatFloat(item?.lotto_admin_fee || 0);

      return pickOrderObj(
        item,
        filteredCols.map((c) => c.key)
      );
    })
  });
};
